export default __webpack_public_path__ + "static/media/get-app-banner.037bcda7.png";